const validateTimes = (time) => {
    const errors = {};

    errors.start = time.start === "" || time.start === null
        ? "Choose a start time"
        : "";

    errors.end = time.end === "" || time.end === null
        ? "Choose an end time"
        : "";

    return errors;
};

export default validateTimes;
